import { render, staticRenderFns } from "./TemplatesHistoryList.vue?vue&type=template&id=009f7349"
import script from "./TemplatesHistoryList.vue?vue&type=script&lang=js"
export * from "./TemplatesHistoryList.vue?vue&type=script&lang=js"
import style0 from "./TemplatesHistoryList.vue?vue&type=style&index=0&id=009f7349&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports